import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import { Button, Toast, Form, Field, NavBar } from 'vant';
Vue.use(Button)
Vue.use(Toast)
Vue.use(Form);
Vue.use(Field);
Vue.use(NavBar)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
